// Percorso file: src/pages/home/HomeChild.jsx
//
// VISTA DELEGATA DEL FIGLIO — ricostruita (cantiere HOME-CHILD).
//
// ⚠️ QUESTA NON È UN ATTERRAGGIO DI RUOLO. Il figlio NON è un ruolo: è un
// PLAYER con `isMinor`. La pagina non sta nella mappa ruolo→rotta
// (auth/access.js, ROLE_ROUTES) e nessun cancello di ruolo la protegge:
// ci si arriva dalla TESSERA del figlio nella home del genitore, e la
// rotta porta l'id del figlio (`/home/child/:childId`).
//
// ⚠️ NIENTE IMPERSONAZIONE, ed è il principio che regge tutto il file.
// Il genitore resta sé stesso: qui NON si chiama `setUser` (AuthContext
// non lo espone nemmeno più), NON si scrive e NON si legge
// `delegatedUser` / `parentBackup` / `userBackend` in `localStorage` — il
// meccanismo di impersonazione della pagina vecchia, demolita con
// questo file, qui non c'è: questa pagina non scrive `delegatedUser`.
// (Il calendario riceve il figlio nello STESSO modo di questa pagina: il
// suo id nella rotta, `/my-calendar/child/:childId` — v. la voce «Calendar
// — Events» più sotto. Nessuna delega, nessun `localStorage`.)
// I dati mostrati sono del FIGLIO e arrivano dal BACKEND, che è la sola
// guardia vera: `GET /users/:id` applica la matrice dei permessi (sé
// stessi / tutore via `guardians` / admin / coach della squadra) e nega
// con 403 tutto il resto. Un non-tutore che digitasse a mano l'id di un
// minore NON vede nulla: la pagina si ferma sul ripiego neutro.
//
// PROTEZIONE DEL MINORE. Se la scheda non si legge — 403, 404 o guasto di
// rete — non si mostra NIENTE del figlio: né nome, né foto, né squadra, e
// nemmeno una spiegazione che riveli se quella persona esista. Resta la
// sola intestazione con il «Back», e un messaggio unico, lo stesso che
// usa la scheda del tesserato: «This profile is not available.»
// Nello stesso ripiego finisce il documento di un ADULTO — `isMinor`
// esplicitamente `false` —, perché «QPSC Minor Area» non si scrive sopra
// un maggiorenne: è una verifica di COERENZA sul documento già letto, non
// un permesso (vedi l'effetto qui sotto).
//
// L'INTESTAZIONE LA DISEGNA QUESTA PAGINA, e non è una svista: il telaio
// comune (HomeShell) porta con sé la barra utente dell'utente COLLEGATO —
// nome, EMAIL e LOGOUT — e qui il nome da mostrare è quello del FIGLIO,
// mentre email e Logout non ci devono stare (l'email del minore non si
// espone in testata, e il Logout in una vista delegata sarebbe una via
// d'uscita sbagliata: la via d'uscita è il «Back», che porta a `/home`,
// l'instradatore — vedi l'avvertenza sull'intestazione più sotto). La
// barra è quindi RICALCATA dal doc 07 §7.1 con classi
// proprie `qpsc-child-userbar-*`, gemelle di quelle di UserBar.css, e
// HomeShell.css NON è toccato. Il «Back» invece è il componente
// CONDIVISO NavBand, senza «Switch role»: in delega non ha senso, il
// cappello del genitore non si cambia da qui.
//
// LE CHIAMATE AL BACKEND SONO DUE, e nessuna delle due scrive:
//   1. `GET /users/:childId` — la scheda del figlio: nome, foto e i suoi
//      `contexts`, cioè le TESSERE, che la rotta restituisce sempre
//      (server.js) ed è di lì che si legge la SQUADRA;
//   2. `GET /teams` — solo per la CATEGORIA della pastiglia (§2), che non
//      sta sull'utente e nemmeno sulla tessera, ma sulla SQUADRA, e la
//      tessera porta il NOME della squadra, non il suo id. Se fallisce non
//      si avvisa e non si riprova: la pastiglia tace e il nome della
//      squadra resta a schermo. È la stessa logica di HomePlayer.jsx e
//      HomeParent.jsx.
// Gli effetti dipendono da STRINGHE (`id`, `squadra`) e mai da oggetti: un
// effetto legato a un oggetto rileggerebbe a ogni render (avvertenza di
// HomeIncomplete.jsx, ripresa in HomeParent e HomePlayer).
//
// LE VOCI. Nessuna è più «coming soon»: My Attendance è stata riaccesa
// (cantiere ATTENDANCE, fetta F3: naviga a /attendance/child/…, col
// figlio nell'indirizzo) e Game Call Ups è stata tolta (R8.2).
// NIENTE Live Chat, per decisione dell'incarico: la messaggistica di un
// minore non si apre in delega. Sono vive lo Shop (link esterno) e
// «My Profile», che NAVIGA alla scheda DEL FIGLIO, in sola lettura.
//
// ⚠️ «CALENDAR — EVENTS» È STATA RIACCESA (cantiere CALENDAR, fetta E),
// per decisione del committente. Il collaudo a schermo dell'1/9/2026 ha
// mostrato che da qui il genitore in delega apre la settimana DEL
// FIGLIO, verificata con un tesserato reale. La destinazione è
// /my-calendar/child/:childId, il calendario del socio col figlio
// nell'indirizzo, ed è la via per cui il genitore raggiunge il calendario, dato
// che nella sua home una voce propria non ce l'ha, per scelta. L'apertura
// è voluta e sta al collaudo, non a questa pagina: la correzione, se
// servirà, è del cantiere del calendario.
//
// ⚠️ «MY PROFILE» NAVIGA, E NON A /myprofile (fase 3 del cantiere View
// Profile). Fino a ieri apriva una FINESTRA sopra questa pagina; oggi la
// scheda del tesserato è una PAGINA su rotta propria e la voce ci manda,
// con l'id della rotta: `/profile/:childId`. Non a `/myprofile`, che
// mostra sempre l'utente COLLEGATO: da qui il genitore vedrebbe sé stesso
// al posto del figlio (è il guasto della pagina vecchia, che lo faceva in
// tre punti). Il «Back» della scheda riporta qui.
// La SOLA LETTURA non dipende da questa pagina: dalla fase 1 del cantiere
// la scheda legge il ruolo di chi guarda per POSSESSO dall'utente
// collegato, e a un genitore i comandi amministrativi non compaiono perché
// non è un admin — non perché di qui non gli si passi una prop. Il
// rovescio, voluto: un genitore che sia ANCHE admin/superadmin li vedrà,
// qui come altrove. Nemmeno la foto è modificabile: la scheda la concede a
// chi guarda sé stesso o agli ADMIN/SUPERADMIN attivi, e un genitore non è
// né l'uno né gli altri (stessa regola del backend su `POST /upload`).

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  FaCalendarAlt,
  FaClipboardCheck,
  FaFutbol,
  FaShoppingBag,
  FaUserCircle
} from "react-icons/fa";
import NavBand from "../../components/NavBand";
import AuthAvatar from "../../components/AuthAvatar";
import { PastigliaCategoriaSeNota } from "../../components/PastigliaCategoria";
import { SOCIAL, SHOP_URL } from "../../components/clubLinks";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../api/api";
import { normalizza } from "../../utils/roleUtils";
// LA SQUADRA DEL FIGLIO SI LEGGE DALLA SUA TESSERA, con il LETTORE UNICO:
// stessa importazione, stessa funzione e stesse opzioni predefinite della
// tessera del figlio in HomeParent.jsx — solo tessere ACTIVE, tessera
// senz'anno esclusa, nessuna tessera amministrativa. Qui non si copia un
// corpo e non si decide nulla: si chiama.
import { squadreDelSoggetto } from "../../utils/squadre";
// IL BOTTONE AUSTRALIA GOAL DELLA SQUADRA (cantiere TEAM-LINK): lo stesso
// componente che montano HomePlayer e HomeCoach, con la sua guardia dentro.
import AustraliaGoalButton from "./AustraliaGoalButton";
// ⚠️ Le classi CONDIVISE del telaio (pagina, colonna, titolo, pulsante
// oro, elenco delle voci, riga social) stanno in HomeShell.css, e le altre
// home le ricevono montando il componente HomeShell. Questa pagina il
// telaio non lo monta — l'intestazione è sua (vedi sopra) — quindi il
// foglio va importato qui, esplicitamente: è una LETTURA, il file non si
// tocca. L'ordine conta: prima le classi condivise, poi quelle di pagina.
import "../../components/HomeShell.css";
import "./HomeChild.css";

const HomeChild = () => {
  // L'id del figlio arriva dalla ROTTA, non da `localStorage` e non da
  // `user`: è il dato che identifica CHI si sta guardando.
  const { childId } = useParams();
  const id = String(childId || "").trim();

  // ⚠️ L'ANNO OPERATIVO viene dalla cassettina di AuthContext, già
  // normalizzato a intero: lo prendono di qui, con questa stessa riga,
  // HomeParent, UsersList, TeamAssignment e MemberProfileModal — nessuna
  // chiamata propria a `GET /season-config`, e un solo posto che dice
  // l'annata. Fuori da `seasonStatus: "ready"` vale `null`, e il predicato
  // dell'anno lo tratta come «annata ignota».
  // ⚠️ NON È UN DATO DELL'UTENTE COLLEGATO travestito: l'anno operativo è
  // del CLUB, non della persona, quindi è lo stesso per il genitore e per
  // il figlio. Di `useAuth()` qui non si legge nient'altro — `user` no:
  // questa pagina mostra il FIGLIO, e nessuna impersonazione.
  const { operatingSeason } = useAuth();
  const annoOperativo = operatingSeason == null ? null : operatingSeason;

  // "caricamento" | "ok" | "errore". L'attesa e il rifiuto NON si
  // confondono: mostrare subito «This profile is not available.» a un
  // genitore in regola sarebbe un lampeggio bugiardo.
  const [stato, setStato] = useState("caricamento");
  const [figlio, setFiglio] = useState(null);

  // Le squadre, come arrivano da GET /teams — i documenti INTERI, non una
  // proiezione. Servono a due cose, entrambe qui sotto: la CATEGORIA della
  // pastiglia e il LINK Australia Goal della squadra.
  const [squadre, setSquadre] = useState([]);

  // ⚠️ LA FINESTRA DEL PROFILO NON C'È PIÙ (cantiere View Profile, fase 3).
  // La scheda del tesserato è una PAGINA su rotta propria: «My Profile» ci
  // NAVIGA, a `/profile/:childId`, e da lì il «Back» riporta qui. Questa
  // pagina resta com'era — menù delle voci, banner, intestazione col nome
  // del figlio — perché non è solo la scheda: è la home delegata del minore.
  const navigate = useNavigate();

  // LA SCHEDA DEL FIGLIO. Il permesso non si valuta qui: si chiede il dato
  // dove il dato sta, e il backend risponde 403 a chi non è tutore. Un
  // rifiuto e un guasto di rete finiscono nello stesso ramo, e per una
  // ragione: distinguerli a schermo direbbe a un estraneo se quell'id
  // esiste.
  useEffect(() => {
    // (Qui si chiudeva la finestra del profilo prima di ogni lettura: se
    //  restava aperta mentre cambiava `:childId` — stessa pagina, altro
    //  figlio — sopra la pagina del figlio NUOVO sarebbe rimasta la scheda
    //  di quello PRECEDENTE. Con la fase 3 la finestra non esiste più: la
    //  scheda è una pagina a sé, e due schede non possono sovrapporsi.)
    if (!id) {
      setStato("errore");
      setFiglio(null);
      return undefined;
    }

    let annullato = false;

    setStato("caricamento");
    setFiglio(null);

    api
      .get(`/users/${encodeURIComponent(id)}`)
      .then((documento) => {
        if (annullato) return;

        if (!documento || typeof documento !== "object") {
          setStato("errore");
          return;
        }

        // ⚠️ COERENZA DEL DOCUMENTO, non un secondo cancello. La guardia
        // d'accesso resta il backend: qui si guarda soltanto il documento
        // GIÀ letto, per non intitolare «QPSC Minor Area» la scheda di un
        // MAGGIORENNE. `isMinor` è un booleano che scrive il SERVER e solo
        // lui: lo calcola dalla data di nascita (`isMinorDaDob`) nel
        // costruttore del documento e lo ricalcola a ogni cambio di `dob`
        // — non è scrivibile da nessuna rotta e da nessun client.
        // ⚠️ IL RIPIEGO SCATTA SOLO SU `false` ESPLICITO. Un documento in
        // cui `isMinor` MANCA (dato vecchio o incompleto) resta un figlio e
        // si mostra: il confronto è stretto — `=== false` — perché
        // `!documento.isMinor` nasconderebbe anche il campo assente, cioè
        // un minore vero. È la stessa grammatica che l'app usa già
        // sull'altro verso (`isMinor === true` in MemberProfileModal e in
        // HomeIncomplete).
        if (documento.isMinor === false) {
          setFiglio(null);
          setStato("errore");
          return;
        }

        setFiglio(documento);
        setStato("ok");
      })
      .catch(() => {
        if (!annullato) {
          setFiglio(null);
          setStato("errore");
        }
      });

    return () => {
      annullato = true;
    };
  }, [id]);

  // Il nome del figlio: va nella barra in testa e serve ad AuthAvatar per
  // le INIZIALI di ripiego quando la foto non c'è. Stessa composizione di
  // UserBar.jsx — `filter(Boolean)` perché un documento può essere privo
  // di uno dei due campi, e in quel caso l'avatar mostra il suo «?».
  const nome = [figlio?.firstName, figlio?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  // LA SQUADRA STA NELLA TESSERA DEL FIGLIO, non sul suo documento. Il
  // campo di persona `figlio.team` NON si legge più: Team Assignment non lo
  // scrive — la squadra si assegna sulla TESSERA — ed era lui a far sparire
  // la riga della squadra a figli che una squadra ce l'hanno. Si legge la
  // coppia canonica `{teams, allTeams}` della tessera dell'anno OPERATIVO,
  // con il lettore unico: è la stessa riga, e lo stesso corpo, della
  // tessera del figlio in HomeParent.jsx.
  // Un figlio ha, di norma, una tessera sola: il nome della squadra è il
  // PRIMO dell'unione. «Tutte le squadre» non è un nome e non se ne inventa
  // uno: si dice a schermo con la stessa parola della Parent Area e della
  // scheda («All teams»), e in quel caso `squadra` resta vuota, quindi la
  // pastiglia tace — non c'è nessuna squadra da cercare.
  const { nomi, tutte } = squadreDelSoggetto(figlio?.contexts, annoOperativo);
  const squadra = tutte ? "" : nomi[0] || "";

  // ⚠️ NON si legge se `squadra` è vuota: senza squadra non c'è pastiglia
  // da riempire, e la chiamata sarebbe sprecata. La dipendenza è la
  // STRINGA `squadra`, non l'oggetto `figlio`.
  useEffect(() => {
    if (!squadra) return undefined;

    let annullato = false;

    api
      .get("/teams")
      .then((dati) => {
        if (!annullato) setSquadre(Array.isArray(dati) ? dati : []);
      })
      .catch(() => {
        /* nessuna categoria: la pastiglia tace */
      });

    return () => {
      annullato = true;
    };
  }, [squadra]);

  // CATEGORIA E LINK della squadra, dallo STESSO documento e con lo stesso
  // `find` (doc 07 §2). Stessa logica di HomePlayer.jsx e di `categoriaDi`
  // in HomeParent.jsx: si cerca per NOME, perché la tessera porta il nome
  // della squadra e non il suo id.
  // ⚠️ La pastiglia porta la CATEGORIA e nient'altro: divisione e
  // campionato NON ci entrano (§2 «Confini»).
  // ⚠️ IL LINK ESCE DA QUI E NON DA UNA SECONDA RICERCA (cantiere
  // TEAM-LINK), esattamente come in HomePlayer.jsx: cambia ciò che il
  // `useMemo` RESTITUISCE — un oggetto invece di una stringa — non ciò che
  // legge. Un campo assente, non testuale o di soli spazi diventa stringa
  // vuota, ed è la stringa vuota che fa tacere il bottone.
  const { categoria, link } = useMemo(() => {
    const voce = squadre.find(
      (t) => t && typeof t === "object" && t.name === squadra
    );
    return voce
      ? {
          categoria: normalizza(voce.category),
          link: String(voce.link || "").trim()
        }
      : { categoria: "", link: "" };
  }, [squadre, squadra]);

  // L'INTESTAZIONE, identica nei due rami della pagina: la barra col nome
  // del figlio (senza email e senza Logout, §7.1 ricalcato) e il solo
  // «Back».
  // ⚠️ IL «BACK» VA A `/home`, NON alla home del genitore. Questa pagina
  // non la aprono solo i tutori: il backend concede `GET /users/:id`
  // anche agli ADMIN/SUPERADMIN attivi e al COACH della squadra del
  // minore, e a loro un «Back» verso `/home/parent` risponderebbe
  // «Access not allowed» (il cancello RequireRole in App.jsx). `/home` è
  // l'INSTRADATORE: manda ciascuno alla home del proprio ruolo, quindi il
  // genitore torna comunque dove tornava prima. Per la stessa ragione qui
  // NON si usa più `ROLE_ROUTES` di auth/access.js: quella è la mappa
  // ruolo→rotta, e la destinazione di questo «Back» non dipende da un
  // ruolo. (La rotta vecchia `/home/homeparent` resta abbandonata.)
  // Nel ramo di ripiego `nome` è vuoto, quindi la barra mostra il solo
  // logo: nessun dato del minore trapela.
  const intestazione = (
    <>
      <header className="qpsc-child-userbar">
        <img
          className="qpsc-child-userbar__logo"
          src="/images/logo.png"
          alt="Queens Park Soccer Club"
        />

        <div className="qpsc-child-userbar__identity">
          {nome && <span className="qpsc-child-userbar__name">{nome}</span>}
        </div>
      </header>

      <NavBand backTo="/home" showSwitch={false} />
    </>
  );

  // RIPIEGO NEUTRO. Vale sia per l'attesa sia per il rifiuto: nessuna
  // foto, nessun nome, nessuna squadra, nessuna voce. Solo intestazione,
  // «Back» e una riga di testo.
  if (stato !== "ok") {
    return (
      <div className="qpsc-page">
        {intestazione}

        <main className="qpsc-column">
          <p className="qpsc-body-text qpsc-body-text--muted">
            {stato === "caricamento"
              ? "Loading…"
              : "This profile is not available."}
          </p>
        </main>
      </div>
    );
  }

  return (
    <div className="qpsc-page">
      {intestazione}

      <main className="qpsc-column">
        {/* LA FOTO DEL FIGLIO, tonda e centrata SOPRA il titolo: stessa
            misura e stesso trattamento della home del giocatore (96px).
            ⚠️ NESSUN margine sotto: il respiro §4 (16px) lo porta già il
            `gap` di `.qpsc-column`; dichiararlo qui lo raddoppierebbe.
            L'identificativo è quello della ROTTA, `id`, che è anche la
            chiave con cui il backend serve la foto. Senza `photoKey`
            AuthAvatar non chiama nemmeno il backend e va diritto al
            ripiego NORMALE — le INIZIALI del nome del figlio. */}
        <div className="qpsc-child-avatar">
          <AuthAvatar
            userId={id}
            photoKey={figlio?.photoUrl || ""}
            name={nome}
            alt={nome || "Child"}
            className="qpsc-child-avatar__photo"
          />
        </div>

        <h1 className="qpsc-page-title">QPSC Minor Area</h1>

        {/* §2 SQUADRA e pastiglia sono UN gruppo orizzontale: la pastiglia
            sta sulla stessa riga della squadra, alla sua destra, centrata
            in verticale. La pastiglia TACE se la categoria non è nota
            (PastigliaCategoriaSeNota): un figlio la cui squadra non ha
            categoria non esibisce un timbro «NO CATEGORY».
            LA RIGA NON SPARISCE PIÙ quando la squadra non c'è: dice «No
            team yet», la stessa parola che la Parent Area scrive sulla
            tessera del figlio — e non «Pending», che nel modello nuovo è
            uno STATO e vuol dire un'altra cosa. Con «tutte le squadre» la
            categoria non è nota per definizione, e la pastiglia tace. */}
        <p className="qpsc-child-teamline">
          <span className="qpsc-child-team">
            {tutte ? "All teams" : squadra || "No team yet"}
          </span>
          <PastigliaCategoriaSeNota category={categoria} />
        </p>

        {/* §7.3 i quattro canali del club: glifi oro nudi, su una riga
            centrata. Gli indirizzi arrivano dalla sede unica,
            components/clubLinks.js, e non si ricopiano — la pagina
            vecchia se li teneva scritti dentro, in quattro <a> a mano. */}
        <div className="qpsc-social">
          {SOCIAL.map(({ href, title, Icon }) => (
            <a
              key={title}
              className="qpsc-social__link"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              title={title}
              aria-label={title}
            >
              <Icon />
            </a>
          ))}
        </div>

        {/* LE VOCI, in un solo <nav>. Il respiro fra loro è quello normale
            del §4, 16px, che porta già `.qpsc-menu` — con DUE eccezioni:
            la prima voce (Calendar) e l'ultima (My Profile) si staccano
            dalle tre centrali con un respiro DOPPIO, 32px. Il doppio non è
            un numero nuovo: è lo stesso scostamento di `.qpsc-parent-menu`
            (HomeParent.css), 16px di margine che si SOMMANO ai 16 di
            gap. Lo porta la classe `.qpsc-child-spaced`, agganciata alla
            voce che APRE il gruppo successivo — My Attendance e My
            Profile — come fa HomeParent, che il margine lo mette sempre in
            testa al blocco che si stacca, mai in coda a quello che lo
            precede.
            Le icone sono Font Awesome su TUTTE le voci, mai emoji: regola
            tutto-o-niente del §5. Il separatore delle voci composte è il
            trattino lungo con spazi (§3.3). */}
        <nav className="qpsc-menu">
          {/* CALENDAR — EVENTS, RIACCESA (cantiere CALENDAR, fetta E):
              naviga a /my-calendar/child/:childId, e questa è la via per
              cui anche il GENITORE
              arriva al calendario, perché nella sua home una voce propria
              non ce l'ha, per scelta.
              La forma è quella della voce viva di questa pagina, «My
              Profile» qui sotto: `<button>` con `onClick` e `navigate`,
              mai un `<Link>`, e l'etichetta senza la coda
              « — coming soon ».
              ⚠️ IL FIGLIO VIAGGIA NELL'INDIRIZZO, ed è il ritocco del
              cantiere del calendario. Prima si navigava a `/my-calendar`
              NUDO: la pagina riceveva quindi il GENITORE, che non porta un
              cappello di squadra, e mostrava la settimana intera del club
              senza filtrare né dire alcun nome. Il collaudo dell'1/9/2026
              la vide «giusta» perché in quella settimana c'erano di fatto i
              soli eventi del figlio — nessun meccanismo di delega esisteva,
              e quel commento è stato tolto perché prometteva ciò che il
              codice non faceva.
              Ora l'id del figlio entra nella rotta come già fa
              `/home/child/:childId`, e il calendario legge il documento del
              FIGLIO per prenderne la squadra. Il permesso resta dov'è: sul
              backend, che a chi non è tutore risponde 403 — e in quel caso
              il calendario non mostra nulla del minore, come questa pagina.
              L'apertura è decisa dal committente (beta). */}
          <button
            type="button"
            className="qpsc-btn-gold"
            onClick={() => navigate(`/my-calendar/child/${encodeURIComponent(id)}`)}
          >
            <span className="qpsc-btn-gold__icon">
              <FaCalendarAlt />
            </span>
            Calendar &mdash; Events
          </button>

          {/* MY ATTENDANCE, RIACCESA (cantiere ATTENDANCE, fetta F3). Come
              Calendar qui sopra, e per la stessa ragione: nella home del
              GENITORE una voce presenze non c'è, per scelta, e questa è la
              via per cui il genitore risponde «ci sarà?» per il figlio.
              La forma è quella della voce viva accanto: `<button>` con
              `onClick` e `navigate`, mai un `<Link>`, e l'etichetta senza
              la coda « — coming soon ».
              ⚠️ IL FIGLIO VIAGGIA NELL'INDIRIZZO, come già fa Calendar: la
              pagina delle presenze legge il documento del FIGLIO per
              prenderne la squadra, e il PERMESSO resta sul backend, che a
              chi non è tutore risponde 403 — in quel caso la pagina non
              mostra nulla del minore.
              ⚠️ Prima voce del gruppo centrale: qui cade il doppio respiro
              che isola Calendar in cima, e `.qpsc-child-spaced` resta dov'è.
              L'apertura è decisa dal committente (beta). */}
          <button
            type="button"
            className="qpsc-btn-gold qpsc-child-spaced"
            onClick={() => navigate(`/attendance/child/${encodeURIComponent(id)}`)}
          >
            <span className="qpsc-btn-gold__icon">
              <FaClipboardCheck />
            </span>
            My Attendance
          </button>

          {/* IL BOTTONE AUSTRALIA GOAL DELLA SQUADRA (cantiere TEAM-LINK),
            DENTRO il `<nav>` delle voci, fra My Attendance e Clinic: stesso
            posto e stesso componente di HomePlayer, perché è la stessa cosa
            — il link della squadra che l'admin imposta, non una voce di
            rotta.
            ⚠️ STA SOLO IN QUESTO RAMO, e non è una dimenticanza: il ripiego
            neutro qui sopra (`stato !== "ok"`) non mostra la squadra, e
            dove non si dice quale sia la squadra non si apre nemmeno la sua
            pagina esterna.
            ⚠️ FUORI dal `<p>` della riga squadra (flex `nowrap`, tiene
            insieme nome e pastiglia).
            ⚠️ NESSUN MARGINE: il respiro §4 (16px) lo porta già il `gap` di
            `.qpsc-menu`; dichiararlo lo raddoppierebbe a 32. */}
        <AustraliaGoalButton link={link} />

          {/* CLINIC / OFF SEASON / SPECIALS (23/9/2026): l'ingresso all'area
              clinic del socio, /clinics, uscito da More per decisione del
              committente. È da QUI che ci arriva il genitore (HomeParent
              non ha il bottone). Etichetta e icona sono quelle del bottone
              admin (HomeAdmin.jsx). Voce INTERNA: `<button>` con
              `navigate`, come le voci vive di questa vista — non la forma
              `<a>` dello Shop, che è un link esterno — e oro NORMALE
              (l'accento resta allo Shop). /clinics è l'area di chi è
              collegato: il figlio da iscrivere lo si sceglie là. */}
          <button
            type="button"
            className="qpsc-btn-gold"
            onClick={() => navigate("/clinics")}
          >
            <span className="qpsc-btn-gold__icon">
              <FaFutbol />
            </span>
            Clinic / Off Season / Specials
          </button>

          {/* Unica voce esterna, e unica variante d'accento della pagina
              (§5.1: al massimo una — My Profile qui sotto resta un
              pulsante oro NORMALE). L'indirizzo arriva da clubLinks. */}
          <a
            className="qpsc-btn-gold qpsc-btn-gold--accent"
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="qpsc-btn-gold__icon">
              <FaShoppingBag />
            </span>
            QPSC Online Shop
          </a>

          {/* ⚠️ NAVIGA, MA NON A /myprofile. Le altre home mandano «My
              Profile» a /myprofile, che mostra sempre l'utente COLLEGATO:
              da qui il genitore vedrebbe sé stesso al posto del figlio (è
              il guasto della pagina vecchia, che lo faceva in tre punti).
              Qui si va alla scheda DEL FIGLIO, con l'id della rotta:
              `/profile/:childId` (fase 3 del cantiere View Profile — prima
              era una finestra aperta sopra questa pagina).
              Resta una vista in SOLA LETTURA, e non perché di qui si passi
              una prop: la scheda legge il ruolo di chi guarda per possesso
              dall'utente collegato, e a un genitore i comandi
              amministrativi non compaiono. Il «Back» della banda riporta
              qui.
              Porta il doppio respiro, che cade fra lo Shop e lei e la
              isola in fondo: le voci sorelle non si muovono. */}
          <button
            type="button"
            className="qpsc-btn-gold qpsc-child-spaced"
            onClick={() => navigate(`/profile/${id}`)}
          >
            <span className="qpsc-btn-gold__icon">
              <FaUserCircle />
            </span>
            My Profile
          </button>
        </nav>

        {/* BANNER DI CHIUSURA, in coda dopo il menu. La resa è del telaio,
            `.qpsc-adbanner` (HomeShell.css): una classe sola per tutte le
            home che lo mostrano. NON è cliccabile: nessun `<a>`, nessun
            `onClick`, nessun `role` — è un'immagine e basta, e sta FUORI
            dal `<nav>` proprio perché non è una voce di
            navigazione. L'immagine è servita da
            `public/`, quindi non si importa: il percorso è assoluto e
            l'URL è CODIFICATO, perché il file sul disco si chiama «footer
            AG.png», con uno spazio nel nome, e in un URL lo spazio è
            `%20`. */}
        <img
          className="qpsc-adbanner"
          src="/assets/footer%20AG.png"
          alt="AustraliaGoal"
        />
      </main>

    </div>
  );
};

export default HomeChild;
